// extracted by mini-css-extract-plugin
export default {"ul-modal-wrapper":"ULModal_ul-modal-wrapper__nFE3Y","prime-modal-wrapper":"ULModal_prime-modal-wrapper__AdIm3"};